export enum TaskSkeletonUrl {
  DESCRIPTION = 'assets/img/skeleton/task-description.gif',
  COMMENT = 'assets/img/skeleton/task-comment.gif',
}
